// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1zZqY","range":"MonthRangeSwitch_range__1sTJN","disabled":"MonthRangeSwitch_disabled__39Tvd"};